document.addEventListener("DOMContentLoaded", function () {

  const menuItems = document.querySelectorAll(".header__inline-menu details");

  menuItems.forEach((item) => {

    let closeTimer;

    // OPEN
    item.addEventListener("mouseenter", () => {
      clearTimeout(closeTimer);
      item.setAttribute("open", "");
    });

    // DELAY CLOSE
    item.addEventListener("mouseleave", () => {
      closeTimer = setTimeout(() => {
        item.removeAttribute("open");
      }, 300); // increase if needed
    });

  });

});